module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [_c('div', [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.userDeletedSucc),
      callback: function($$v) {
        _vm.userDeletedSucc = $$v
      },
      expression: "userDeletedSucc"
    }
  }, [_vm._v("\n          User Deleted Successfully\n        ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "error"
    },
    model: {
      value: (_vm.userDeletedFail),
      callback: function($$v) {
        _vm.userDeletedFail = $$v
      },
      expression: "userDeletedFail"
    }
  }, [_vm._v("\n          Failed to delete user. Please contact support.\n        ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("New User")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (this.editedIndex > -1) ? _c('v-btn', {
    attrs: {
      "loading": _vm.emailSending
    },
    on: {
      "click": function($event) {
        return _vm.sendResetEmail()
      }
    }
  }, [_vm._v("\n                Send Reset Email\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "newUser",
    model: {
      value: (_vm.newUserValid),
      callback: function($$v) {
        _vm.newUserValid = $$v
      },
      expression: "newUserValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Full Name",
      "rules": [function (v) { return !!v || 'Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.editedItem.Name),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Name", $$v)
      },
      expression: "editedItem.Name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email",
      "rules": [
        function (v) { return !!v || 'Email is required'; },
        function (v) { return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          v
        ) || 'E-mail must be valid'; } ],
      "required": "",
      "append-icon": this.editedIndex > -1 ? 'lock' : '',
      "readonly": this.editedIndex > -1
    },
    model: {
      value: (_vm.editedItem.Email),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Email", $$v)
      },
      expression: "editedItem.Email"
    }
  }), _vm._v(" "), (this.editedIndex < 0) ? _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password",
      "rules": [
        function (v) { return !!v || 'Password is required'; },
        function (v) { return v.length > 6 ||
        'Password must be at least 6 characters'; } ],
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Select Role",
      "items": _vm.roles
    },
    model: {
      value: (_vm.editedItem.Role),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Role", $$v)
      },
      expression: "editedItem.Role"
    }
  }), _vm._v(" "), (_vm.editedItem.Role === 'Supplier') ? _c('v-select', {
    attrs: {
      "label": "Minumum Job Status that can be invoiced",
      "items": [{
          text: 'Completed',
          value: 2
        },
        {
          text: 'Cubo Approved',
          value: 3
        } ]
    },
    model: {
      value: (_vm.editedItem.minInvoiceStatus),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "minInvoiceStatus", $$v)
      },
      expression: "editedItem.minInvoiceStatus"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Select Supplier",
      "items": _vm.suppliers,
      "item-text": "name",
      "item-value": "key"
    },
    model: {
      value: (_vm.editedItem.Company),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Company", $$v)
      },
      expression: "editedItem.Company"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    ref: "customerSelect",
    attrs: {
      "label": "Select Company",
      "items": _vm.customers,
      "item-text": "customerName",
      "item-value": "id",
      "placeholder": "Leave blank to select all",
      "chips": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(index < 5) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.customerName))])]) : _vm._e(), _vm._v(" "), (index === 5) ? _c('span', {
          staticClass: "text-grey text-caption align-self-center"
        }, [_vm._v("\n                            (+" + _vm._s(_vm.editedItem.Customers.length - 5) + " others)\n                          ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.editedItem.Customers),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "Customers", $$v)
      },
      expression: "editedItem.Customers"
    }
  }), _vm._v(" "), ([
    'Engineer',
    'Supplier',
    'Support and Engineer',
    'Admin and Engineer' ].indexOf(_vm.editedItem.Role) !== -1) ? _c('v-checkbox', {
    attrs: {
      "label": "Access to unassigned jobs"
    },
    model: {
      value: (_vm.editedItem.unassigned),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "unassigned", $$v)
      },
      expression: "editedItem.unassigned"
    }
  }) : _vm._e(), _vm._v(" "), ([
    'Engineer',
    'Supplier',
    'Support and Engineer',
    'Admin and Engineer' ].indexOf(_vm.editedItem.Role) !== -1) ? _c('v-checkbox', {
    attrs: {
      "label": "Access to SMS tool"
    },
    model: {
      value: (_vm.editedItem.canSMS),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "canSMS", $$v)
      },
      expression: "editedItem.canSMS"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": "",
      "disabled": !_vm.newUserValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.users,
      "search": _vm.search,
      "item-key": "id",
      "loading": _vm.tableLoading,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Role))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.supplierObj[props.item.Company] === undefined ?
          "-----" :
          _vm.supplierObj[props.item.Company].name) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteItem(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b3e8cc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/User.vue
// module id = 742
// module chunks = 1